import PropTypes from "prop-types";
import Typography, { TYPOGRAPHY_VARIANTS } from "app/pages/.shared/Typography/Typography";
import { Button } from "app/components/ui/Button/Button";
import IconClose from "app/pages/.shared/IconClose";
import "./FilterChip.scss";

export const FilterChip = ({ label, onRemove }) => {
	if (!label) {
		return null;
	}

	return (
		<div className="filter-chip">
			<Typography
				variant={TYPOGRAPHY_VARIANTS.REGULAR}
				component="span"
				className="filter-chip__label"
			>
				{label}
			</Typography>

			<Button
				variant="borderless"
				size="icon-md"
				startIcon={<IconClose />}
				className="filter-chip__remove-button"
				onClick={onRemove}
			/>
		</div>
	);
};

FilterChip.propTypes = {
	label: PropTypes.string.isRequired,
	onRemove: PropTypes.func.isRequired,
};
